import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import * as types from "../../../constants/ComponentConstants";
import { getPropertyFilesComponentProps, downloadFileFromByteArray } from "../../../components/common/FilesHelperUtil";
import { UserTypes } from "../../../constants/DomainConstants";

import { Popup } from 'semantic-ui-react';
import Form from "../../common/Form";
import Section from "../../common/Section";
import TextInput from "../../common/TextInput";
import TextAreaInput from "../../common/TextAreaInput";
import Files from "../../common/Files";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";
import Date from "../../common/Date";
import SelectInput from "../../common/SelectInput";
import LinkInput from "../../common/LinkInput";

const OrganisatieForm = (props) => {
    const {
        model,
        originalModel,
        onChange,
        onChangeFile,
        onSave,
        errors,
        validationMessageType,
        disabled,
        onDropFile,
        onRemoveFile,
        nameHasFocus,
        userType,
        niveaus,
        organisatieTypes
    } = props;

    const niveausPerOrg = model.type ? niveaus.filter(niv => niv.orgType == model.type) : [];

    const logoFilesMimeTypes = 'image/png, image/jpeg, image/gif, image/bmp';
    const logoFilesExtensions = 'jpg, gif, bmp, png';

    let logoFilesProps = getPropertyFilesComponentProps("Logo", types.FileComponentNames.LOGO, null, model.logo && model.logo.content ? [model.logo] : [], originalModel.logo && originalModel.logo.content ? [originalModel.logo] : [], false, onDropFile, onRemoveFile, onChangeFile, {
        mimeTypes: logoFilesMimeTypes,
        extensions: logoFilesExtensions
    }, null, null, null, null, 6, "white", disabled);

    logoFilesProps.showImage = true;
    logoFilesProps.imageContent = model.logo ? model.logo.content : null;
    logoFilesProps.optional = true;

    if (model.logo)
        logoFilesProps["downloadFunction"] = () => downloadFileFromByteArray(model.logo.name, model.logo.content);

    const documentatieFilesMimeTypes = 'application/pdf';
    const documentatieFilesExtensions = 'pdf';

    const documentatieFilesProps = getPropertyFilesComponentProps("Documentatie", types.FileComponentNames.DOCUMENTATIE, null, model.documentatie && model.documentatie.content ? [model.documentatie] : [], originalModel.documentatie && originalModel.documentatie.content ? [originalModel.documentatie] : [], false, onDropFile, onRemoveFile, onChangeFile, {
        mimeTypes: documentatieFilesMimeTypes,
        extensions: documentatieFilesExtensions
    }, null, null, null, null, 6, "white", disabled);

    if (model.documentatie)
        documentatieFilesProps["downloadFunction"] = () => downloadFileFromByteArray(model.documentatie.name, model.documentatie.content);

    documentatieFilesProps.optional = true;

    return (
        <Section title="Organisatiegegevens" color={types.COLOR_BLUE}>
            <Form name="organisatie"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Bewaar"
                onRightButtonClick={onSave}
                rightButtonDisabled={disabled}
            >
                <Fieldset>
                    {userType === UserTypes.WEBSITEBEZOEKER ?
                        <Row>
                            <SelectInput
                                items={organisatieTypes}
                                size={6}
                                name="type"
                                label="Type"
                                value={model.type}
                                onChange={onChange}
                                validationMessage={errors ? errors['type'] : ""}
                                validationMessageType={validationMessageType}
                                defaultItemVisible={false}
                                disabled
                                markChange
                                hideRevert
                                originalValue={originalModel.type}
                            />
                            <SelectInput
                                items={niveausPerOrg}
                                size={6}
                                name="niveau"
                                label="Niveau"
                                value={model.niveau}
                                onChange={onChange}
                                validationMessage={errors ? errors['niveau'] : ""}
                                validationMessageType={validationMessageType}
                                defaultItemVisible={false}
                                disabled
                                markChange
                                hideRevert
                            />
                        </Row>
                        : null}
                    <Row>
                        <TextInput
                            name="naam"
                            label="Naam"
                            value={model.naam}
                            originalValue={originalModel.naam}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['naam'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            hasFocus={nameHasFocus}
                        />
                        <TextInput
                            name="afkorting"
                            label="Afkorting"
                            value={model.afkorting}
                            originalValue={originalModel.afkorting}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['afkorting'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                    </Row>
                    <Row>
                        {model.website && 
                            <div className={classnames(["c-linkmask", "o-col-1"])}>
                                {<Popup trigger={<a href={model.website.startsWith("http") ? model.website : `//${model.website}`} target="_blank">
                                    <i className={classnames(["fa fa-fw fa-globe c-globe", "c-linkicon"])}></i>
                                </a>} content={`Test hier je link: ${model.website}`} />}&nbsp;
                                <b>{props.inputmask}</b>
                            </div>
                        }

                        <TextInput
                                name="website"
                                label="Website"
                                value={model.website}
                                originalValue={originalModel.website}
                                onChange={onChange}
                                disabled={disabled}
                                validationMessage={errors ? errors['website'] : ""}
                                validationMessageType={validationMessageType}
                                size={model.website ? 11 : 12}
                                optional
                            />
                    </Row>
                    <Row>
                        <TextInput
                                name="email"
                                label="Email 1"
                                value={model.email}
                                originalValue={originalModel.email}
                                onChange={onChange}
                                disabled={disabled}
                                validationMessage={errors ? errors['email'] : ""}
                                validationMessageType={validationMessageType}
                                size={6}
                                optional
                            />
                        <TextInput
                            name="gsm"
                            label="GSM"
                            value={model.gsm}
                            originalValue={originalModel.gsm}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['gsm'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="email2"
                            label="Email 2"
                            value={model.email2}
                            originalValue={originalModel.email2}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['email2'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                        <TextInput
                            name="telefoon"
                            label="Telefoon"
                            value={model.telefoon}
                            originalValue={originalModel.telefoon}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['telefoon'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                
                    </Row>
                    <Row>
                        <TextAreaInput
                            name="extraGegevens"
                            label="Extra Gegevens"
                            value={model.extraGegevens}
                            originalValue={originalModel.extraGegevens}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['extraGegevens'] : ""}
                            validationMessageType={validationMessageType}
                            size={12}
                            optional
                        />
                    </Row>
                    <Row>
                        <Files {...logoFilesProps} maxFileLimit={1} />
                        <Files {...documentatieFilesProps} maxFileLimit={1} />
                    </Row>
                    <Row>
                        <p className="o-col-12" style={{ textAlign: 'center' }}>
                            Laatst gewijzigd door Sport Vlaanderen: <Date value={model.datumLaatsteWijziging} />
                        </p>
                        <p className="o-col-12" style={{ textAlign: 'center' }}>
                            Gecreëerd door Sport Vlaanderen op: <Date value={model.datumAanmaak} />
                        </p>
                    </Row>
                </Fieldset>
            </Form>
        </Section>);
};

OrganisatieForm.propTypes = {
    model: PropTypes.object,
    originalModel: PropTypes.object,
    onDropFile: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeFile: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    disabled: PropTypes.bool,
    nameHasFocus: PropTypes.bool,
    userType: PropTypes.string,
    niveaus: PropTypes.array,
    organisatieTypes: PropTypes.array,
};

export default OrganisatieForm;